export default __webpack_public_path__ + "static/100--stacked-area-8eb3d6a6af369b32fc9ee8e4aef7a6c0.png";